/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Operations for send GTM events
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Julia Ignatieva
 * @version 1.12.0
 * @since 1.0.0
 */

import { EGTMAccountType } from '../GTMconstants';
import * as gtmAccountInfoOperations from './GTMAccountInfoOperations';
import * as gtmAuthOperations from './GTMAuthOperations';
import * as gtmBasketOperations from './GTMBasketOperations';
import * as gtmCashbackOperations from './GTMCashbackOperations';
import * as gtmNavOperations from './GTMNavOperations';
import * as gtmPageViewOperations from './GTMPageViewOperations';
import * as gtmUserSettingsOperations from './GTMUserSettingsOperations';
import * as gtmWidgetCostsOperations from './GTMWidgetCostsOperations';
import * as gtmWidgetHistoryPaymentOperations from './GTMWidgetHistoryPaymentsOperations';
import * as gtmWidgetOrderInquiriesOperations from './GTMWidgetOrderInquiriesOperations';
import * as gtmWidgetPersonalAccountOperations from './GTMWidgetPersonalAccountOperations';
import * as gtmWidgetSearchAccountsOperations from './GTMWidgetSearchAccountsOperations';
import * as gtmWidgetSubscriberMaxCostsOperations from './GTMWidgetSubscriberMaxCostsOperations';
import * as gtmWidgetSubscriberMobileOperations from './GTMWidgetSubscriberMobileOperations';
import * as gtmWidgetUsefulLinksOperations from './GTMWidgetUsefulLinksOperations';

const GTMOperations = {
    accountInfo: gtmAccountInfoOperations,
    auth: gtmAuthOperations,
    basket: gtmBasketOperations,
    cashback: gtmCashbackOperations,
    navigation: gtmNavOperations,
    pageView: gtmPageViewOperations,
    userSettings: gtmUserSettingsOperations,
    widgetCosts: gtmWidgetCostsOperations,
    widgetHistoryPayment: gtmWidgetHistoryPaymentOperations,
    widgetOrderInquiries: gtmWidgetOrderInquiriesOperations,
    widgetPersonalAccount: gtmWidgetPersonalAccountOperations,
    widgetSearchAccounts: gtmWidgetSearchAccountsOperations,
    widgetSubscriberMaxCosts: gtmWidgetSubscriberMaxCostsOperations,
    widgetSubscriberMobile: gtmWidgetSubscriberMobileOperations,
    widgetUsefulLinks: gtmWidgetUsefulLinksOperations,
};

export interface IGTMOperation {
    b2bLK_account_type?: EGTMAccountType;
    event?: string;
    event_cat?: string;
    event_id?: string;
    event_name?: string;
    event_param?: string;
    login?: number | null;
    personal_accounts?: number | null;
    susr_id?: number;
    user_role?: number;
}

/**
 * @description Call Operation on Init GTM
 * @param {string} susrId ( login )
 * @param {string} bisCustomerId ( personal_accounts )
 */
export const onInitGTMOperation = (susrId: number | null, bisCustomerId: number | null): void => {
    gtmOperationPush({
        'login' : susrId,
        'personal_accounts' : bisCustomerId,
    })
};

export const gtmOperationPush = (operations: IGTMOperation): void => {
    if (window.dataLayer) {
        window.dataLayer.push(operations);
    }
};

export default GTMOperations;
